import { gql } from '@apollo/client'

export const LOCATION_DATA_QUERY = gql`
  query LocationDataQuery {
    location {
      country
    }
  }
`
